"use client";

import { sanitizeCredentialedBrowserUrl } from "@/lib/auth/sanitizeCredentialedUrl";
import { ThemeProvider } from "next-themes";
import { useEffect } from "react";

export default function ThemeProviderClient({
  children,
}: {
  children: React.ReactNode;
}) {
  useEffect(() => {
    sanitizeCredentialedBrowserUrl();
  }, []);

  return (
    <ThemeProvider
      attribute="class"
      defaultTheme="light"
      enableSystem={false}
      // Product owner decision: the customer portal must stay permanently pinned
      // to the light theme, including /user routes, regardless of OS/browser theme.
      forcedTheme="light"
      disableTransitionOnChange
    >
      {children}
    </ThemeProvider>
  );
}
